import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUnlockAlt,
  faCalendarAlt,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import moment from "moment-timezone";
import Datetime from "react-datetime";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import {
  Form,
  Card,
  Col,
  InputGroup,
  Button,
  Row,
  Spinner,
} from "@themesberg/react-bootstrap";
import {
  tenDigitRegexStartingWith9,
  EMAIL_REGEX,
} from "../../helpers/regexHelper";
import {
  clearIndividualSahakari,
  deleteSahakariById,
  getSahakariById,
  updateSahakari,
} from "../../redux/actions/sahakari";
import DateFormatHelper from "../../helpers/DateFormatHelper";
import CustomErrorView from "../../components/CustomErrorView";
import CustomDashboardLoader from "../../components/CustomDashboardLoader";
import ConfirmActionModal from "../../components/ConfirmActionModal";
import { graceOptions } from "../../helpers/Constants";

const initialErrors = {
  errorName: "",
  errorEmail: "",
  errorUsername: "",
  errorPassword: "",
  errorPhone: "",
  errorAddress: "",
  errorExpiresDate: "",
};
const initialValues = {
  name: "",
  email: "",
  username: "",
  password: "",
  phone: "",
  address: "",
  gracePeriod: 0,
  isActiveSahakari: true,
};

function EditSahakari({ match, history }) {
  const dispatch = useDispatch();

  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);
  const [sahakariId, setSahakariId] = useState("");

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showErrPage, setShowErrPage] = useState(false);

  const [expiresDate, setExpiresDate] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState(initialErrors);
  const {
    name,
    email,
    username,
    password,
    phone,
    address,
    gracePeriod,
    isActiveSahakari,
  } = values;
  const {
    errorName,
    errorEmail,
    errorUsername,
    errorPassword,
    errorPhone,
    errorAddress,
    errorExpiresDate,
  } = errors;

  const loadSuccess = (responseData) => {
    const initalObject = {
      name: responseData.name,
      email: responseData.email,
      username: responseData.username,
      password: "",
      phone: responseData.mobileNumber,
      address: responseData.sahakari.location,
      isActiveSahakari: responseData.sahakari.isActive,
    };
    setValues(initalObject);
    setExpiresDate(responseData.sahakari.expirationDate);
    setSahakariId(responseData.sahakari.id);
    setIsActive(responseData.sahakari.isActive);
    setIsLoading(false);
  };
  const loadFailure = () => {
    setIsLoading(false);
    setShowErrPage(true);
  };

  useEffect(() => {
    const someId = match.params?.id;
    if (!someId) {
      setShowErrPage(true);
    } else {
      setIsLoading(true);
      dispatch(getSahakariById(someId, loadSuccess, loadFailure));
    }
    return () => {
      dispatch(clearIndividualSahakari());
    };
  }, []);

  const handleSuccess = () => {
    setIsSubmitting(false);
  };
  const handleFaliure = () => {
    // alert("Login failed");
    setIsSubmitting(false);
  };

  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const errorHandler = (key, val) => {
    setErrors((current) => {
      return { ...current, [key]: val };
    });
  };
  const handleDeleteSuccess = () => {
    history.replace("/");
  };
  const handleDeleteFailure = () => {
    setIsSubmitting(false);
  };

  const deleteSahakariHandler = () => {
    setIsSubmitting(true);
    dispatch(
      deleteSahakariById(sahakariId, handleDeleteSuccess, handleDeleteFailure)
    );
  };

  const isActiveHandler = () => {
    setIsSubmitting(true);
    const data = {
      sahakariId,
      isActive,
    };
    dispatch(updateSahakari(data, handleSuccess, handleFaliure));
  };

  const graceSubmitHandler = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const data = {
      sahakariId,
      gracePeriod,
    };
    dispatch(updateSahakari(data, handleSuccess, handleFaliure));
  };

  const passwordChangeHandler = (e) => {
    e.preventDefault();
    let hasErrors = false;
    if (!/\S/.test(password)) {
      hasErrors = true;
      errorHandler("errorPassword", "Password cannot be empty");
    } else if (password.length < 6) {
      hasErrors = true;
      errorHandler(
        "errorPassword",
        "Password should be minimum of 6 characters long"
      );
    } else {
      errorHandler("errorPassword", "");
    }

    if (hasErrors) {
      toast.error("Please check all the form fields");
    } else {
      setIsSubmitting(true);
      const data = {
        sahakariId,
        adminPassword: password,
      };
      dispatch(updateSahakari(data, handleSuccess, handleFaliure));
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();
    let hasErrors = false;
    if (!/\S/.test(name)) {
      hasErrors = true;
      errorHandler("errorName", "Name cannot be empty");
    } else {
      errorHandler("errorName", "");
    }
    if (!/\S/.test(email)) {
      hasErrors = true;
      errorHandler("errorEmail", "Email cannot be empty");
    } else if (!EMAIL_REGEX.test(email)) {
      hasErrors = true;
      errorHandler("errorEmail", "Enter a valid email");
    } else {
      errorHandler("errorEmail", "");
    }
    // if (!/\S/.test(username)) {
    //   hasErrors = true;
    //   errorHandler("errorUsername", "Username cannot be empty");
    // } else {
    //   errorHandler("errorUsername", "");
    // }

    if (!/\S/.test(phone)) {
      hasErrors = true;
      errorHandler("errorPhone", "Phone cannot be empty");
    } else if (!tenDigitRegexStartingWith9.test(phone)) {
      hasErrors = true;
      errorHandler(
        "errorPhone",
        "Phone should be of 10 digits starting with 9"
      );
    } else {
      errorHandler("errorPhone", "");
    }
    if (!/\S/.test(address)) {
      hasErrors = true;
      errorHandler("errorAddress", "Address cannot be empty");
    } else {
      errorHandler("errorAddress", "");
    }
    if (!/\S/.test(expiresDate)) {
      hasErrors = true;
      errorHandler("errorExpiresDate", "Subscription Date cannot be empty");
    } else {
      errorHandler("errorExpiresDate", "");
    }

    if (hasErrors) {
      toast.error("Please check all the form fields");
    } else {
      setErrors(initialErrors);
      setIsSubmitting(true);
      const expirationDateString = moment(expiresDate).format("YYYY/MM/DD");
      const data = {
        sahakariId,
        adminName: name,
        adminEmail: email,
        location: address,
        expirationDate: DateFormatHelper(expirationDateString),
        adminMobileNumber: phone,
      };
      //   dispatch(createSahakari(data, handleSuccess, handleFaliure));
      dispatch(updateSahakari(data, handleSuccess, handleFaliure));
    }
  };

  if (showErrPage) {
    return <CustomErrorView />;
  } else {
    return (
      <div>
        {isLoading ? (
          <CustomDashboardLoader />
        ) : (
          <>
            <ConfirmActionModal
              show={showModal}
              disableButtons={isSubmitting}
              handleClose={handleCloseModal}
              handleAction={deleteSahakariHandler}
              actionTitle="Confirm Delete"
              closeTitle="Cancel"
              title={"Delete Sahakari?"}
              subTitle="Are you sure yow want to delete this sahakari? All the associated records and data related to this sahakari will be lost forever"
            />
            <Col md={12} className={"mt-3"}>
              <Card border="light" className="bg-white shadow-sm mb-4 p-0">
                <Card.Body>
                  <div
                    className="d-flex"
                    style={{
                      // background: "red",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <h5>Edit Sahakari Info</h5>
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={handleShowModal}
                    >
                      <FontAwesomeIcon icon={faTrash} className="me-1" /> Delete
                      Sahakari
                    </Button>
                  </div>

                  <Form onSubmit={submitHandler}>
                    <Row>
                      <Col md={6} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder=""
                            name="name"
                            onChange={onChange}
                            value={name}
                          />
                          {errorName !== "" && (
                            <Form.Text className="text-danger">
                              {errorName}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Email address</Form.Label>
                          <Form.Control
                            required
                            type="email"
                            name="email"
                            value={email}
                            // placeholder="name@example.com"
                            onChange={onChange}
                          />
                          {errorEmail !== "" && (
                            <Form.Text className="text-danger">
                              {errorEmail}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Username</Form.Label>
                          <Form.Control
                            required
                            type="text"
                            name="username"
                            disabled={true}
                            value={username}
                            // placeholder="username"
                            onChange={onChange}
                          />
                          {errorUsername !== "" && (
                            <Form.Text className="text-danger">
                              {errorUsername}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>

                      <Col md={6} className="mb-3">
                        <Form.Group id="phone">
                          <Form.Label>Phone</Form.Label>
                          <Form.Control
                            name="phone"
                            required
                            type="number"
                            value={phone}
                            // placeholder="98XXXXXXXX"
                            onChange={onChange}
                          />
                          {errorPhone !== "" && (
                            <Form.Text className="text-danger">
                              {errorPhone}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mb-3">
                        <Form.Group className="mb-3">
                          <Form.Label>Address</Form.Label>
                          <Form.Control
                            name="address"
                            type="text"
                            value={address}
                            // placeholder="Address"
                            onChange={onChange}
                          />
                          {errorAddress !== "" && (
                            <Form.Text className="text-danger">
                              {errorAddress}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mb-3">
                        <Form.Group id="expiresdate">
                          <Form.Label>Subscription until:</Form.Label>
                          <Datetime
                            timeFormat={false}
                            name="expirationDate"
                            onChange={setExpiresDate}
                            renderInput={(props, openCalendar) => (
                              <InputGroup>
                                <InputGroup.Text>
                                  <FontAwesomeIcon icon={faCalendarAlt} />
                                </InputGroup.Text>
                                <Form.Control
                                  required
                                  type="text"
                                  value={
                                    expiresDate
                                      ? moment(expiresDate).format("YYYY/MM/DD")
                                      : ""
                                  }
                                  placeholder="yyyy/mm/dd"
                                  onFocus={openCalendar}
                                  onChange={() => {}}
                                />
                              </InputGroup>
                            )}
                          />
                          {errorExpiresDate !== "" && (
                            <Form.Text className="text-danger">
                              {errorExpiresDate}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                    <div className="d-flex justify-content-end">
                      <Button
                        type="submit"
                        variant="primary"
                        className="m-1"
                        onClick={submitHandler}
                        disabled={isSubmitting}
                      >
                        {isSubmitting === true ? (
                          <Spinner animation="border" />
                        ) : (
                          "Update Sahakari"
                        )}
                      </Button>
                    </div>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
            {/* PASSWORD SECTION */}
            <Col md={12} className={"mt-3"}>
              <Card border="light" className="bg-white shadow-sm mb-4 p-0">
                <Card.Body>
                  <h5 className="mb-4">Change Password</h5>

                  <Form onSubmit={passwordChangeHandler}>
                    <Row>
                      <Col md={12} className="mb-3">
                        <Form.Group id="password" className="mb-4">
                          <Form.Label>Password</Form.Label>
                          <InputGroup>
                            <InputGroup.Text>
                              <FontAwesomeIcon icon={faUnlockAlt} />
                            </InputGroup.Text>
                            <Form.Control
                              required
                              name="password"
                              type="password"
                              value={password}
                              // placeholder="Password"
                              onChange={onChange}
                            />
                          </InputGroup>
                          {errorPassword !== "" && (
                            <Form.Text className="text-danger">
                              {errorPassword}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                    <div className="d-flex justify-content-end">
                      <Button
                        variant="primary"
                        className="m-1"
                        onClick={passwordChangeHandler}
                        disabled={isSubmitting}
                      >
                        {isSubmitting === true ? (
                          <Spinner animation="border" />
                        ) : (
                          "Change Password"
                        )}
                      </Button>
                    </div>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
            {!isActiveSahakari && (
              <Col md={12} className="mt-3">
                <Card border="light" className="bg-white shadow-sm mb-4 p-0">
                  <Card.Body>
                    <h5 className="mb-4">Grace Period</h5>
                    <Form>
                      <Form.Select
                        aria-label="Default select example"
                        value={gracePeriod}
                        onChange={(e) =>
                          setValues({
                            ...values,
                            gracePeriod: e.target.value,
                          })
                        }
                      >
                        <option value={null}>{null}</option>
                        {graceOptions.map((item) => (
                          <option value={item.value} key={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </Form.Select>
                      <div className="d-flex justify-content-end">
                        <Button
                          type="submit"
                          variant="primary"
                          className="mt-4"
                          onClick={graceSubmitHandler}
                          disabled={isSubmitting}
                        >
                          {isSubmitting === true ? (
                            <Spinner animation="border" />
                          ) : (
                            "Add Grace Period"
                          )}
                        </Button>
                      </div>
                    </Form>
                  </Card.Body>
                </Card>
              </Col>
            )}
            Enable / Disable Section (Manually)
            <Col md={12} className={"mt-3"}>
              <Card border="light" className="bg-white shadow-sm mb-4 p-0">
                <Card.Body>
                  <div
                    className="d-flex"
                    style={{
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <h5>
                      {isActive
                        ? "Save to Activate this Account"
                        : "Save to Disable this Account"}
                    </h5>
                    <Form>
                      <Form.Check
                        type="switch"
                        id="custom-switch"
                        checked={isActive}
                        onChange={() => setIsActive((curr) => !curr)}
                      />
                    </Form>
                  </div>
                  <div className="d-flex justify-content-end mt-4">
                    <Button
                      variant={isActive ? "primary" : "danger"}
                      className="m-1"
                      onClick={isActiveHandler}
                      disabled={isSubmitting}
                    >
                      {isSubmitting === true ? (
                        <Spinner animation="border" />
                      ) : isActive ? (
                        "Activate"
                      ) : (
                        "Deactivate"
                      )}
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </>
        )}
      </div>
    );
  }
}

export default EditSahakari;
